import MainLayout from '@/layouts/MainLayout.vue';
import UserLogin from '@/views/login/UserLogin.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const children = [
  {
    path: 'parsing/:id',
    name: 'AiVideoParsing',
    meta: { auth: true, sideTabAlign: 'vertical', feature: 'ai_video_parsing' },
    components: {
      default: () => import('@/views/video/parsing/AiProcess.vue'),
      intro: () => import('@/views/video/parsing/AiIntro.vue'),
      asr: () => import('@/views/video/parsing/AiAsr.vue')
    }
  },
  {
    path: 'moments/:id',
    name: 'AiVideoMoments',
    meta: { auth: true, sideTabAlign: 'horizontal', feature: 'ai_video_moments' },
    components: {
      default: () => import('@/views/video/moments/AiProcess.vue'),
      intro: () => import('@/views/video/moments/AiIntro.vue'),
      asr: () => import('@/views/video/moments/AiAsr.vue')
    }
  },
  {
    path: 'clip/:id',
    name: 'AiVideoClip',
    meta: { auth: true, sideTabAlign: 'horizontal', feature: 'ai_video_clip' },
    components: {
      default: () => import('@/views/video/clip/AiProcess.vue'),
      intro: () => import('@/views/video/clip/AiIntro.vue'),
      asr: () => import('@/views/video/clip/AiAsr.vue')
    }
  },
  {
    path: 'summary/:id',
    name: 'AiVideoSummary',
    meta: { auth: true, sideTabAlign: 'horizontal', feature: 'ai_video_summary' },
    components: {
      default: () => import('@/views/video/summary/AiProcess.vue'),
      intro: () => import('@/views/video/summary/AiIntro.vue'),
      asr: () => import('@/views/video/summary/AiAsr.vue')
    }
  },
  {
    path: 'subtitles/:id',
    name: 'AiVideoSubtitles',
    meta: { auth: true, sideTabAlign: 'vertical', feature: 'ai_video_subtitles' },
    components: {
      default: () => import('@/views/video/subtitles/AiProcess.vue'),
      intro: () => import('@/views/video/subtitles/AiIntro.vue'),
      asr: () => import('@/views/video/subtitles/AiAsr.vue')
    }
  }
];

// 标品使用
export const videoRouter = [
  {
    path: '/video',
    component: MainLayout,
    name: 'AiVideo',
    children: children
  }
];

// 三方嵌入使用
export const embedVideoRouter = [
  {
    path: '/embed/video',
    component: MainLayout,
    name: 'EmbedAiVideo',
    children: children
  }
];

// 企微嵌入使用
export const embedWxworkVideoRouter = [
  {
    path: '/embed/wxwork/login',
    name: 'login',
    component: UserLogin
  },
  {
    path: '/embed/wxwork/material',
    component: DefaultLayout,
    props: { hasMsgMonitor: true, hasHeadBar: true },
    children: [
      {
        path: '',
        component: () => import('@/views/material/MediaList.vue'),
        meta: {
          auth: true
        }
      }
    ]
  },
  {
    path: '/embed/wxwork/video',
    component: MainLayout,
    name: 'EmbedWxworkAiVideo',
    children: children
  }
];
